import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background text-muted-foreground">
        Carregando…
      </div>
    );
  }

  if (!user) {
    // Usuários sem sessão são enviados para /entrar (também é o start_url do PWA).
    return <Navigate to="/entrar" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
